import React from "react";

type Props = { label: string };

const StepTitle = ({ label }: Props) => (
  <div className="text-sm font-bold">{label}</div>
);

export default StepTitle;
